import * as Sentry from '@sentry/browser';
import { Integrations } from '@sentry/tracing';
import { SentryDSN } from 'shared/sentry.io';

(function () {
    if (
        window.__SENTRY_IO_CONFIG &&
        window.__SENTRY_IO_CONFIG.hasOwnProperty('FEATURE_FLAG') &&
        window.__SENTRY_IO_CONFIG.FEATURE_FLAG &&
        window.__SENTRY_IO_CONFIG.hasOwnProperty('CORE_ENABLED') &&
        window.__SENTRY_IO_CONFIG.CORE_ENABLED
    ) {
        new Sentry.init({
            dsn: SentryDSN.frontend,
            release: window.__SENTRY_IO_CONFIG.BUILD_NUMBER ?? '',
            environment: window.location.hostname,
            integrations: [new Integrations.BrowserTracing()],
            tracesSampleRate: 0.1,
        });
    }
})();
